import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Authentication from "../pages/auth/Authentication";

export default function AuthGuard() {
  const token = useSelector((state) => state.user.token);

  if (token) {
    return <Navigate to="/" />;
  } else
    return (
      <>
        <Authentication />
      </>
    );
}
